module.exports = __webpack_public_path__ + "media/images/flags/SH-a322534d71a8abd8ee44cc2bdea4ba00.svg";